import { render, staticRenderFns } from "./indexAi.vue?vue&type=template&id=22b35eb8&scoped=true"
import script from "./indexAi.vue?vue&type=script&lang=ts"
export * from "./indexAi.vue?vue&type=script&lang=ts"
import style0 from "./indexAi.vue?vue&type=style&index=0&id=22b35eb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b35eb8",
  null
  
)

export default component.exports